import { prop } from 'ramda'

import type { AdditionalSettingsType, Params } from 'app/dataTypes/dishes/additionalSettings'

import type { Request } from '../../../index'



type ApiParams = {
  school_id: number,
  item_id: number, //id продукции
}


export const convertParams = (params: Params): [ApiParams, null] => {
  const { orgId, dishId } = params
  return [{
    school_id: parseInt(orgId, 10),
    item_id: dishId
  }, null]
}


type ApiResult = {
  result: 'success'
  settings: {
    disable_for_terminal_guest_sales: boolean  // Не продавать гостям в терминале самообслуживания
  }
}


export const convertResult = (data: ApiResult): AdditionalSettingsType => {
  const items = prop('settings', data) || {}
  return ({
    disableForTerminalGuestSales: items.disable_for_terminal_guest_sales
  })
}

export const GET_ADDITIONAL_SETTINGS: Request<Params, AdditionalSettingsType, void> = [
  'food/items/additional_settings',
  'get',
  ['data'],
]
